import { X } from "lucide-react";

export default function PromoBanner({ onClose }) {
  return (
    <div
      data-testid="promo-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-[#241B2E] text-[#F4E7CE]"
    >
      <div className="max-w-7xl mx-auto px-4 h-10 flex items-center justify-center gap-3 relative">
        <img src="/halloween/jack-o-lantern.png" alt="" className="w-5 h-5 object-contain" />
        <p className="text-xs sm:text-sm tracking-wide text-center">
          <span className="font-semibold text-[#E2711D]">Halloween Special</span>
          <span className="hidden sm:inline"> — Book a seasonal deep-clean and get </span>
          <span className="sm:hidden"> — </span>
          <span className="font-semibold">15% off</span>. Limited spots!
        </p>
        <button
          data-testid="promo-banner-close"
          onClick={onClose}
          aria-label="Dismiss announcement"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F4E7CE]/70 hover:text-[#F4E7CE] transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
